import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin", { replace: true });
      return;
    }

    const sessionId = decodeURIComponent(match[1]);
    api.post("/auth/session", { session_id: sessionId })
      .then(r => {
        setUser(r.data);
        // strip hash
        window.history.replaceState({}, "", window.location.pathname);
        navigate("/admin", { replace: true, state: { user: r.data } });
      })
      .catch(() => {
        navigate("/admin", { replace: true });
      });
  }, [navigate, location, setUser]);

  return (
    <div className="page-container">
      <div className="parchment-card p-8 max-w-md mx-auto text-center">
        <div className="tavern-heading text-2xl gold-text">Unlocking the keeper's quarters…</div>
        <div className="tavern-script text-lg mt-2" style={{color:"var(--orchid-light)"}}>one moment, traveler</div>
      </div>
    </div>
  );
}
